export default {"src":"/_next/static/media/0x448bbbdb706cd0a6ab74fa3d1157e7a33dd3a4a8.3bd8ca5a.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};